export default __webpack_public_path__ + "static/media/about-frame.e4646e64.png";